"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9178],{

/***/ 39178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ bottomBar_BottomBar; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9725);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/shared/ButtonLink.styled.tsx
var ButtonLink_styled = __webpack_require__(8536);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./services/service.event-tracking.ts + 1 modules
var service_event_tracking = __webpack_require__(27862);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./features/public-companies/components/bottomBar/BottomBar.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: sticky;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: ",
        ";\n  background-color: ",
        ";\n  color: ",
        ";\n  transform: translateY(100%);\n  transition: opacity 0.2s;\n  margin-top: -3.5rem;\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n\n  @keyframes ShowBar {\n    to {\n      transform: translateY(0);\n    }\n  }\n\n  &.is-scroll {\n    animation: ShowBar 0.5s 1.5s forwards;\n  }\n\n  &.is-detached {\n    opacity: 0;\n    pointer-events: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  max-width: ",
        ";\n  padding-right: ",
        ";\n  padding-left: ",
        ";\n  margin: auto;\n  overflow: hidden;\n\n  @media (min-width: ",
        ") {\n    justify-content: flex-end;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledBottomBar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4138aec4-0"
})(_templateObject(), (0,theme/* zindex */.Y0)("bottomBar"), (0,theme/* color */.$_)("midnight_900"), (0,theme/* color */.$_)("text_default_inverse"), (0,theme/* spacing */.W0)("xs"), (0,theme/* spacing */.W0)("xs"));
var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4138aec4-1"
})(_templateObject1(), (0,theme/* container */.nC)("xlMax"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("sm"), (0,theme/* screen */.sp)("md"));

;// CONCATENATED MODULE: ./features/public-companies/components/bottomBar/BottomBar.tsx








var BottomBar = function() {
    var t = (0,useI18n/* useI18n */.Q)("companies-new").t;
    var bottomBarRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), setAttached = ref[0], setAttachedState = ref[1];
    var ref1 = (0,react.useState)(false), isScroll = ref1[0], setScrollState = ref1[1];
    var handleScroll = function() {
        var ref;
        var heroHeight = ((ref = document.querySelector(".companiesHero")) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect().height) || 150;
        var bottomBarPosition = heroHeight;
        setScrollState(true);
        if (bottomBarRef === null || bottomBarRef === void 0 ? void 0 : bottomBarRef.current) {
            bottomBarPosition = bottomBarRef.current.getBoundingClientRect().bottom;
        }
        setAttachedState(window.innerHeight > bottomBarPosition);
    };
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            return window.removeEventListener("scroll", handleScroll);
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBottomBar, {
        ref: bottomBarRef,
        className: "".concat(setAttached ? "is-detached" : "", " ").concat(isScroll ? "is-scroll" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink_styled/* default */.C, {
                href: "#companiesForm",
                variant: "primaryInverse",
                sizes: "md",
                onClick: function() {
                    return service_event_tracking/* default.trackLandingCtaClicked */.Z.trackLandingCtaClicked("hablemos-footer-empresas");
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_solid_svg_icons/* faCheckCircle */.f8k
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t("companies-new.bottomBar.cta")
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var bottomBar_BottomBar = (BottomBar);


/***/ })

}]);